import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    maxWidth: 200,
  },
});

export default function ServiceCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root} id="services">
      <CardActionArea id="action">
        <CardMedia
          component="img"
          alt=""
          height="130"
          image={props.imgSrc}
          title=""
        />
        <CardContent>
          <Typography gutterBottom variant="subtitle2" component="h2">
            {props.title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

// <CardActions />
